import { ProviderId } from "@indeed/signals-schema/com/indeed/signals/schema/reactnative/ProviderId";

const isProviderId = (v: string): v is ProviderId =>
  (Object.values(ProviderId) as string[]).includes(v);

export const getRnErrorProviderId = (provider: string): ProviderId => {
  return isProviderId(provider) ? provider : ProviderId.Unknown;
};
